import {Locales} from '@netx/core-next/locales/utils/Locales';

export const AutoListFieldLabel = Locales((i18n) => ({
	LOADING: i18n(`i18n.loading`),
	NO_INPUT: i18n(`i18n.startTypingForOptions`),
	NO_MATCHES: i18n(`i18n.noMatches`),
}));
